// extracted by mini-css-extract-plugin
export default {"paragraph":"Views_paragraph__j4rwA","globalContainer":"Views_globalContainer__6no7L","selected":"Views_selected__W-uHW","principal":"Views_principal__4BLCX"};